import PageHeader from "../components/PageHeader";
import { GALLERY } from "../lib/site";
import { Seo } from "../components/Seo";

const sizeClass = (s) => {
  if (s === "lg") return "md:col-span-2 md:row-span-2 aspect-square md:aspect-auto";
  if (s === "md") return "md:col-span-1 md:row-span-1 aspect-[4/3]";
  return "md:col-span-1 md:row-span-1 aspect-[4/3]";
};

export default function Gallery() {
  return (
    <div data-testid="page-gallery">
      <Seo
        path="/gallery"
        title="Gallery — Recent BMW, Audi, Porsche & Subaru Builds"
        description="Photos of recent European and Subaru imports through Dirty Wrenches Automotive in Hermiston, OR. BMW M4, M5, Porsche 911 GT3, Audi RS6 & R8, Mercedes-AMG GT, Subaru BRZ and more."
      />
      <PageHeader
        code="// 04"
        kicker="Gallery"
        title={<>Cars in the bay.<br />Cars out the door.</>}
        subtitle="A small slice of what passes through. We don't post every car — but the ones we do, we're proud of."
        testId="gallery-header"
      />

      <section className="px-6 md:px-12 lg:px-24 py-20 md:py-28">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 auto-rows-[220px] md:auto-rows-[260px] gap-3 md:gap-4">
          {GALLERY.map((g, i) => (
            <figure
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden border border-white/10 bg-[#1A1F24] ${sizeClass(g.size)}`}
            >
              <img
                src={g.url}
                alt={g.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/0 to-transparent opacity-90" />
              <figcaption className="absolute inset-x-0 bottom-0 p-4 md:p-5 flex items-center justify-between">
                <span className="font-display font-bold uppercase tracking-tight text-sm md:text-base">{g.tag}</span>
                <span className="font-mono-tech text-[10px] text-[#FF3B30] tracking-[0.3em] uppercase">{String(i + 1).padStart(2, "0")}</span>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-16 border border-white/10 bg-[#0A0A0A] p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <div className="font-mono-tech text-[11px] text-[#FF3B30] tracking-[0.3em] uppercase">// follow along</div>
            <div className="font-display font-black uppercase tracking-tight text-2xl md:text-3xl mt-2">
              More builds posted on the regular.
            </div>
            <p className="text-white/60 mt-2 max-w-xl">
              We tag every car we touch. If you've seen one of ours and want the same — we can probably do that.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
